import React, {useEffect} from "react";
import {
    checkPageNameExists,
    checkHasSpaces,
    checkIfEmpty
} from '../../../validations/validations'
import PopUpValidationCore from './PopUpValidationCore';

/*
This component renders a pop up that is being displayed when user want to change the name of a page It asks the user to save or 
cancel the new name
*/
const RenamePagePopUp = (props) => {

    const {
        openEditPage,
        setOpenEditPage,
        selectedPage,
        selectedProject,
        projectNamesPages,
        setProjectNamesPages,
        savedPageClicked
    }= props;

    const [pageName, setPageName] = React.useState();
    const [initialName, setInitialName] = React.useState();
    
    /*
    This useEffect is runned when edit pop up window is opened.It initializes the current name of the page.At var pageName we 
    store the new name.
    */
    useEffect( () => {
        if(openEditPage === true){
            if(selectedProject > -1 && selectedPage > -1){
                const tempPageName = JSON.parse(localStorage.getItem('data'))[selectedProject].pages[selectedPage].name;
                setPageName(tempPageName);
                setInitialName(tempPageName);
            }
        } 
    },[openEditPage])

    // This function is fired when cancel button is pressed. It stores the old project to projectNamesPages var and then saves the page.
    const handleCancel = () => {
        
        const tempProjectNamesPages = [...projectNamesPages];
        tempProjectNamesPages[selectedProject] = projectNamesPages[selectedProject];
        tempProjectNamesPages[selectedProject][selectedPage] = initialName;
        setProjectNamesPages(tempProjectNamesPages);
        
        savedPageClicked();
        setOpenEditPage(false);
    }

    //  This function is fired when user edits the new name of the page.It stores the edited name to projectNamesPages var and updates the text input
    const handlePageName = (val) => {

        const tempProjectNamesPages = [...projectNamesPages];
        tempProjectNamesPages[selectedProject] = projectNamesPages[selectedProject];
        tempProjectNamesPages[selectedProject][selectedPage] = val.target.value;
        setProjectNamesPages(tempProjectNamesPages);

        setPageName(val.target.value);
    }

    /*
    This function is fired when update button is pressed.If the new name does not exist does not has spaces or is empty then it saves the 
    new page name and closes the edit pop up window.
    */
    const updateAttributes = () => {
        if(checkPageNameExists(pageName,selectedProject,selectedPage)=== false && checkHasSpaces(pageName) === false && checkIfEmpty(pageName) === false){
            savedPageClicked();
            setOpenEditPage(false);
        }     
    }
 
    return(
        <PopUpValidationCore
            title='Rename page name'
            page_description='Page name'
            open={openEditPage}
            setOpen={setOpenEditPage}
            handlePageName={handlePageName}
            pageName={pageName}
            selectedProject={selectedProject}
            handleCancel={handleCancel}
            updateAttributes={updateAttributes}
            selectedPage={selectedPage}
            cause='RenamePage'
        />
    )
}

export default RenamePagePopUp;